//If you want to support older IE, Android, and iOS device web browsers,
/*import 'core-js'
import 'regenerator-runtime/runtime'
import 'intersection-observer' // Optional*/

//core dependencies
import Vue from 'vue'
import VueRouter from 'vue-router';
import VueWorker from 'vue-worker';
import App from './App.vue';
import routes from '../routes';
import VueI18n from 'vue-i18n'

//cookies
import VueCookies from 'vue-cookies';

import {authMiddleware} from '../middleware/auth';
import store from '../store/store';

import BootstrapVue from 'bootstrap-vue';

Vue.use(VueWorker);
Vue.use(BootstrapVue);
Vue.use(VueI18n)

import '../assets/css/pe-icon-7-stroke.css';
import '../assets/css/fontawesome-all.css';

//validation dependencies
import { ValidationObserver, ValidationProvider, extend, localize, validate } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';

//require('dotenv').config({ path: '.env.local' });


// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize('en', en);

// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(VueCookies);

const router = new VueRouter({
  mode: 'history', //no hash in url, like normal routing
  routes: routes
});

Vue.prototype.$getAccessToken = function(){
  console.log("pridobivamo access token")
  return fetch( process.env.VUE_APP_API + '/auth/access', {
    method : 'post',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'CSRF-Token': Vue.prototype.$csrf
    }
  })
  .then(response => {
    console.log("vrnjen response")
    if(response.status == 200){
      return response.json();
    }
    return Vue.prototype.$logout();
  });
}

/*Vue.prototype.$logout = function(){
  return fetch( process.env.VUE_APP_API + '/logout', {
    method : 'post',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'CSRF-Token': Vue.prototype.$csrf
    }
  }).then(() => {
    return location.href="/login";
  });
}*/

Vue.prototype.$logout = function(){
  return Promise.all([deleteSession(), deleteToken()])
    .then(() => {
      return location.href="/login";
      //return router.push('/login');

    });
}

function deleteSession(){
  return fetch( process.env.VUE_APP_API + '/auth/access', {
    method : 'delete',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'CSRF-Token': Vue.prototype.$csrf
    }
  });
}

function deleteToken(){
  return fetch( process.env.VUE_APP_API + '/auth/refresh', {
    method : 'delete',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'CSRF-Token': Vue.prototype.$csrf
    }
  });
}


fetch(process.env.VUE_APP_API + '/csrf/token', {
  method: 'get',
  credentials: 'include'
})
.then(response => response.json())
.then(response => {
  return Vue.prototype.$csrf = response.token
})
.then(async () => {

  router.beforeEach(await authMiddleware);

  //router.afterEach(cssLoader)

  const i18n = new VueI18n({
    locale: 'sl'
  });

  new Vue({
    store,
    render: h => h(App),
    i18n,
    router,
  }).$mount('#app')
})
